const isIE = (): boolean => {
  return (
    window.navigator.userAgent.indexOf("MSIE") > -1 ||
    window.navigator.userAgent.indexOf("rv:11") > -1
  )
}

const isWindow7: boolean =
  window.navigator.userAgent.indexOf("Windows NT 6.1") > -1 && isIE()

export { isWindow7 }
